/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import CIIcon from './CIIcon'

function StickyAdPreview({ srcs, redirectUrl }) {
  const containerRef = useRef(null)
  const [showSecondImage, setShowSecondImage] = useState(true)
  const pic1Ref = useRef(null)
  const [pic1Top, setPic1Top] = useState(null)

  const getSafeImageSrc = (file) => {
    if (file instanceof Blob) {
      return URL.createObjectURL(file)
    }
    if (typeof file === 'string') {
      if (file.startsWith('blob:')) return file
      return `/api/file/${file}`
    }
    return ''
  }

  useEffect(() => {
    if (pic1Ref.current && containerRef.current) {
      const pic1Rect = pic1Ref.current.getBoundingClientRect()
      const containerRect = containerRef.current.getBoundingClientRect()
      const bottomFromContainer = containerRect.bottom - pic1Rect.top
      setPic1Top(bottomFromContainer)
    }
  }, [srcs])

  return (
    <div
      className="scroller-hide"
      ref={containerRef}
      // style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100">
        {/* `Pic 1` */}
        {srcs.length > 0 && srcs[0].file && (
          <>
            <img
              role="presentation"
              ref={pic1Ref}
              className="d-flex"
              src={getSafeImageSrc(srcs[0].file)}
              alt={srcs[0].label}
              style={{
                width: '21.25%',
                position: 'absolute',
                objectFit: 'contain',
                bottom: '0%',
                height: '15%',
                zIndex: '1501',
              }}
              onClick={() => {
                if (redirectUrl) window.open(redirectUrl, '_blank')
              }}
            />
            <CIIcon right="19%" bottom="0%" />
          </>
        )}

        {/* `Pic 2` */}
        {showSecondImage && srcs.length > 1 && srcs[1].file && (
          <div
            style={{
              position: 'absolute',
              bottom: pic1Top !== null ? `${pic1Top}px` : '24%',
              width: '100%',
              zIndex: '1',
            }}
          >
            <img
              role="presentation"
              className="d-flex"
              src={getSafeImageSrc(srcs[1].file)}
              alt={srcs[1].label}
              style={{
                objectFit: 'cover',
                height: '8%',
                width: '21.25%',
              }}
              onClick={() => {
                if (redirectUrl) window.open(redirectUrl, '_blank')
              }}
            />
            <Button
              onClick={() => setShowSecondImage(false)}
              style={{
                position: 'absolute',
                top: '20px',
                right: '80.5%',
                transform: 'translate(50%, -50%)',
                background: 'rgba(0, 0, 0, 0.8)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                fontSize: '14px',
                cursor: 'pointer',
                zIndex: '1501',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0',
              }}
            >
              ✕
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

StickyAdPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  redirectUrl: PropTypes.string,
}

StickyAdPreview.defaultProps = {
  srcs: [],
  redirectUrl: '',
}

export default StickyAdPreview
